import {
    connect,
} from 'react-redux';

import {
    numberOfProductsInCart,
    totalPriceOfProductsInCart,
} from 'components/shop/helpers';

import CheckoutBar from '../components/CheckoutBar';

const mapStateToProps = ({ shop }) => ({
    numberOfProductsInCart: numberOfProductsInCart(shop.cart),
    totalPriceOfProductsInCart: totalPriceOfProductsInCart(shop.cart),
});

const mapDispatchToProps = () => ({

});

const container = connect(
    mapStateToProps,
    mapDispatchToProps,
)(CheckoutBar);

export default container;



// WEBPACK FOOTER //
// ./resources/components/shop/containers/CheckoutBarContainer.js